import { Component, OnInit } from '@angular/core';
import { CustomMatIconRegistryService } from './core/services/custom-mat-icon-registry.service';

@Component({
  selector: 'tad-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private customMatIconRegistryService: CustomMatIconRegistryService,
  ) {}

  public ngOnInit(): void {
    this.customMatIconRegistryService.init();

  }
}
